import axios from "axios";
import { createOrder_stripe } from "../utils/Constant";
import { FREE_ORDER_PAYMENT_TOKEN } from "./freeOrder";
import { getFinalTotalDollars } from "./checkoutTotals";

function formatMoney(value) {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return "0.00";
  return Math.max(0, num).toFixed(2);
}

/**
 * Build JSON body for POST /createOrder_stripe
 * @see https://panel.whitelabelmd.com/nextvial/api/createOrder_stripe
 */
export function buildStripeOrderPayload(paymentToken, ctx, productId, options = {}) {
  const billingSame = ctx.sameAsShipping;
  const isFreeOrder =
    options.isFreeOrder === true ||
    paymentToken === FREE_ORDER_PAYMENT_TOKEN;

  const products = ctx.getproducts || [];
  const originalFromProducts = products.reduce(
    (sum, product) => sum + (parseFloat(product.product_price) || 0),
    0
  );
  const originalPrice = formatMoney(
    ctx.original_price != null && ctx.original_price !== ""
      ? ctx.original_price
      : originalFromProducts
  );

  const finalPrice = isFreeOrder
    ? "0.00"
    : formatMoney(
        getFinalTotalDollars(
          originalPrice,
          ctx.discount_percent,
          ctx.discount_amount
        )
      );

  const contactDetailsId =
    options.contactDetailsId || ctx.contact_details_id || null;

  const productIds = products
    .map((p) => p?.product_id)
    .filter((id) => id != null && id !== "")
    .map((id) => parseInt(String(id), 10))
    .filter((id) => !Number.isNaN(id));

  const resolvedProductId =
    productIds.length > 0
      ? productIds.length === 1
        ? productIds[0]
        : productIds
      : parseInt(String(productId), 10);

  return {
    email: ctx.email,
    first_name: ctx.firstName,
    last_name: ctx.lastName,
    phone: ctx.phoneNumber || "",
    address: ctx.address,
    city_name: ctx.city,
    state_name: ctx.getselectedStateCode?.state_code || "",
    zip_code: ctx.postalCode,
    start_url:
      typeof window !== "undefined" ? window.location.href : ctx.start_url || "",
    payment_token: paymentToken,
    product_id: resolvedProductId,
    product_price: finalPrice,
    original_price: originalPrice,
    billing_model_id: "3",
    qty: "1",
    address2: ctx.aptSuite || "",
    billing_address: billingSame ? ctx.address : ctx.address2,
    billing_address2: "",
    billing_city_name: billingSame ? ctx.city : ctx.city2,
    billing_state_name: billingSame
      ? ctx.getselectedStateCode?.state_code || ""
      : ctx.getselectedStateCode2?.state_code || "",
    billing_zip_code: billingSame ? ctx.postalCode : ctx.postalCode2,
    billingSameAsShipping: billingSame ? "YES" : "NO",
    promo_codes: ctx.appliedDiscount || null,
    campaign_id: ctx.getcampaignID || null,
    discount_amount:
      ctx.discount_amount != null && ctx.discount_amount !== ""
        ? String(ctx.discount_amount)
        : null,
    sms_non_marketing_consent: ctx.smsTransactional ? 1 : 0,
    sms_marketing_consent: ctx.smsMarketing ? 1 : 0,
    ...(contactDetailsId ? { contact_details_id: contactDetailsId } : {}),
    ...(ctx.checkout_link_id
      ? { checkout_link_id: ctx.checkout_link_id }
      : {}),
  };
}

export async function postStripeOrder(
  paymentToken,
  ctx,
  productId,
  options = {}
) {
  const body = buildStripeOrderPayload(paymentToken, ctx, productId, options);
  return axios.post(createOrder_stripe, body, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export function aggregateStripeOrderResponses(responses) {
  const successOrders = [];
  const failedOrders = [];
  let message = "";

  for (const response of responses) {
    const data = response?.data || {};
    message = data.message || message;

    if (Array.isArray(data.success_orders)) {
      successOrders.push(...data.success_orders.map(String));
    } else if (data.status == 1 && data.order_id) {
      successOrders.push(String(data.order_id));
    }

    if (Array.isArray(data.failed_orders)) {
      failedOrders.push(...data.failed_orders.map(String));
    }
  }

  return { successOrders, failedOrders, message };
}
